import React from 'react';

const TrainerPackages = () => {
    return (
        <div>
            Trainer purched packages
        </div>
    );
};

export default TrainerPackages;